import { isGlobalAttributeType } from '@src/emp-3.0/components/custom-dimension/utils/checks';
import {
  ALL_APPLICABLE_MAPPED_EVENTS_TYPE,
  SPECIFIC_MAPPED_EVENT_TYPE,
} from '@src/emp-3.0/constants/dimensions';

export function generateSelectEventType(
  attributeType: number,
  mappedEventNames: string[],
  defaultAllSelectEventType: string = ALL_APPLICABLE_MAPPED_EVENTS_TYPE,
): string {
  let newSelectEventType: string = defaultAllSelectEventType;

  const isGlobalAttribute = isGlobalAttributeType(attributeType);
  if (!isGlobalAttribute) {
    newSelectEventType = mappedEventNames.length
      ? SPECIFIC_MAPPED_EVENT_TYPE
      : defaultAllSelectEventType;
  }

  return newSelectEventType;
}

export function generateCustomDimensionPayload(data) {
  const {
    custom_dimension_id,
    display_name,
    category,
    attribute_name,
    attribute_type,
    mapped_event_names,
    is_promoted_as_global,
  } = data;
  const payload = {
    display_name,
    category,
    attribute_name,
    mapped_event_names,
    attribute_type,
    is_promoted_as_global,
  };
  if (custom_dimension_id) {
    return {
      custom_dimension_id,
      ...payload,
    };
  }
  return payload;
}
